export const NOTIFICATION_TYPES_MAPPING = {
  CONVERSATION_MENTION: ['i-ph-at', 'text-n-blue-11'],
  CONVERSATION_ASSIGNMENT: ['i-ph-caret-double-right', 'text-n-blue-11'],
  CONVERSATION_CREATION: ['i-ph-envelope-simple', 'text-n-blue-11'],
  PARTICIPATING_CONVERSATION_NEW_MESSAGE: [
    'i-ph-chat-circle',
    'text-n-blue-11',
  ],
  ASSIGNED_CONVERSATION_NEW_MESSAGE: ['i-ph-chat-circle', 'text-n-blue-11'],
  SLA_MISSED_FIRST_RESPONSE: ['i-ph-heart-break', 'text-n-ruby-11'],
  SLA_MISSED_NEXT_RESPONSE: ['i-ph-heart-break', 'text-n-ruby-11'],
  SLA_MISSED_RESOLUTION: ['i-ph-heart-break', 'text-n-ruby-11'],
};
